import { render, staticRenderFns } from "./join.vue?vue&type=template&id=2ef87d20&scoped=true&lang=pug"
import script from "./join.vue?vue&type=script&lang=js"
export * from "./join.vue?vue&type=script&lang=js"
import style0 from "../access.scss?vue&type=style&index=0&id=2ef87d20&prod&lang=scss&scoped=true&external"
import style1 from "./join.vue?vue&type=style&index=1&id=2ef87d20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef87d20",
  null
  
)

export default component.exports